import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

type FooterProps = {
    bgColor?: string;
    titleColor?: string;
    descColor?: string;
    borderTopColor?: string;
    boxStyle?: Record<string, string | number>;
};

export default function IRAFooter({ bgColor, titleColor, descColor, borderTopColor = '#444', boxStyle }: FooterProps) {
    const { isMobile } = useGlobal();
    const langItem = {
        footerTitle: 'Disclaimer',
        desc: '*Please note that EcoFlow does not provide guarantees and assurances concerning tax credits that may be associated with our products. Any information we provide is solely for educational purposes and should not be construed as legal advice. Determining your eligibility for tax credits is a highly personalized matter. You should always consult your tax professional to determine your eligibility for the Residential Clean Energy Credit under Section 25D of the Internal Revenue Code given your individual situation.',
        dateText: 'Effective date: Jan 1, 2023',
    };

    return (
        <div
            className={`GtmModuleData-section ${styles.IRAFooter}`}
            id="IRAFooter"
            data-section-id={styles.IRAFooter}
            data-section-title={langItem.footerTitle}
        >
            <div className={`${isMobile ? 'mobile-footer' : 'pc-footer'}`} style={{ backgroundColor: bgColor || '#000' }}>
                <div className="ira-footer" style={{ ...boxStyle, borderTop: `1px solid ${borderTopColor}` }}>
                    <div className="title" style={{ color: titleColor || '#D7D7D7' }}>
                        {langItem.footerTitle}
                    </div>
                    <div className="desc" style={{ color: descColor || '#757575' }}>
                        {langItem.desc}
                    </div>
                    <div className="desc date-text" style={{ color: descColor || '#757575' }}>
                        {langItem.dateText}
                    </div>
                </div>
            </div>
        </div>
    );
}
